import React from 'react';
import ServiceDetailPage from './Common/ServiceDetailPage';

const ServiceMobileAppDevelopment = () => {
  return (
    <ServiceDetailPage
      title="Mobile App Development"
      heading="Mobile applications designed for everyday users and growing businesses"
      intro="App Core Innovation creates mobile apps that are intuitive, fast, and built around real user needs. Whether the goal is a customer-facing app or an internal productivity tool, we focus on practical delivery and a polished experience."
      imageSrc="/assets/images/banner/gradient-texture-technology-twitter-header_23-2149156062.avif"
      imageAlt="Mobile app development illustration"
      features={[
        'iOS and Android application development',
        'Cross-platform solutions for faster rollout',
        'Secure user flows and smooth onboarding',
        'Integration with APIs, databases, and cloud services'
      ]}
      deliverables={[
        'App architecture and screen flows',
        'Frontend mobile experience and API integration',
        'Testing and launch preparation',
        'Support for future feature updates'
      ]}
      outcomes={[
        'A mobile product that feels native and user-friendly',
        'Better engagement and stronger customer interaction',
        'A scalable app foundation for future growth'
      ]}
      stats={[
        { label: 'Platforms', value: 'iOS + Android' },
        { label: 'Best fit', value: 'Customer apps' },
        { label: 'Approach', value: 'User-first' }
      ]}
      sideTitle="Why this service matters"
      sideText="Mobile apps often become the most visible part of a product. We build them to feel reliable, useful, and easy to trust from the first interaction."
    />
  );
};

export default ServiceMobileAppDevelopment;
